// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1oDmG","load6":"Spinner_load6__2aFpD","round":"Spinner_round__3nzEl"};